import React, { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { setBeaconSearchText, setCategoryFilter } from "../../../redux/actions";

const BeaconSearchText: React.FC = () => {

  const dispatch = useAppDispatch();
  const beaconState = useAppSelector(state => state.beacon);

  const [searchText, setSearchText] = useState<string | undefined>(beaconState.searchText ?? undefined);

  useEffect(() => {

    if (searchText !== beaconState.searchText) {
      setSearchText(beaconState.searchText ?? undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [beaconState.searchText]);

  const handleSearchTextChange = (text: string) => {
    setSearchText(text);
  };

  useEffect(() => {

    // searchText will be undefined if the text is cleared by filter.
    //  We don't need to run search in this case.
    if (searchText !== undefined) {
      const delayDebounceFn = setTimeout(() => {
        // Initialise filter selection. Can not query for both text and category
        dispatch(setCategoryFilter(null));

        dispatch(setBeaconSearchText(searchText ?? null));

      }, 1000); // Start searching with delay to wait for user's input

      return () => clearTimeout(delayDebounceFn);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <TextField
      id="search"
      type="search"
      label="Search"
      variant="standard"
      value={searchText ?? ""}
      sx={{ width: 200, marginBottom: 1, marginRight: 1 }}
      onChange={(event) => { handleSearchTextChange(event.target.value); }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default BeaconSearchText;
